// extracted by mini-css-extract-plugin
module.exports = {"Container":"LanguageSwitcher_Container__36neI","Open":"LanguageSwitcher_Open__2mzfn","List":"LanguageSwitcher_List__27oEY","ml":"LanguageSwitcher_ml__3ih40"};